import { inherits as _inherits, classCallCheck as _classCallCheck, createSuper as _createSuper } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { CachedDOMMeasurement as CachedDOMMeasurement$1 } from './CachedDOMMeasurement.js';

/** Dynamically gets the value of any provided CSS custom property. */

var CachedCSSProperty = /*#__PURE__*/function (_CachedDOMMeasurement) {
  _inherits(CachedCSSProperty, _CachedDOMMeasurement);

  var _super = _createSuper(CachedCSSProperty);

  function CachedCSSProperty(cssProperty, element, fallbackValue) {
    var _this;

    _classCallCheck(this, CachedCSSProperty);

    _this = _super.call(this, element, fallbackValue);
    _this.cssProperty = cssProperty;
    _this.cssProperties = [cssProperty];
    return _this;
  }

  return CachedCSSProperty;
}(CachedDOMMeasurement$1);

export { CachedCSSProperty };
